var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 0C31.0277 0 39.9995 8.9719 39.9995 19.9997C39.9995 31.0276 31.0276 39.9995 19.9997 39.9995C8.97189 39.9995 0 31.0276 0 19.9997C0 8.9719 8.97189 0 19.9997 0ZM19.9997 2.16216C10.164 2.16216 2.16216 10.1641 2.16216 19.9997C2.16216 22.9793 2.89757 25.7901 4.19487 28.2616C5.04663 29.8846 6.14054 31.3613 7.42918 32.6427C10.6561 35.8513 15.1003 37.8373 19.9997 37.8373C29.8354 37.8373 37.8373 29.8354 37.8373 19.9997C37.8373 17.2481 37.2107 14.6401 36.0931 12.3105C35.1108 10.263 33.7485 8.43108 32.0988 6.90568C28.9169 3.96325 24.665 2.16216 19.9997 2.16216ZM30.476 25.4054V27.8686H9.59459V25.4054H30.476ZM13.4684 13.3781C14.6625 13.3781 15.6305 14.3461 15.6305 15.5403C15.6305 16.7344 14.6625 17.7024 13.4684 17.7024C12.2743 17.7024 11.3062 16.7344 11.3062 15.5403C11.3062 14.3461 12.2743 13.3781 13.4684 13.3781ZM26.8468 13.3781C28.0409 13.3781 29.0089 14.3461 29.0089 15.5403C29.0089 16.7344 28.0409 17.7024 26.8468 17.7024C25.6526 17.7024 24.6846 16.7344 24.6846 15.5403C24.6846 14.3461 25.6526 13.3781 26.8468 13.3781Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.6f1833fc8a3257ce2a96e423b19951ac.svg";
export { ForwardRef as ReactComponent };